var PasswordValidation = (function(selector, options) {

    var data = {};
    var elBubble = undefined;
    var elBubbleResponsive = undefined;
    var required = false;
    var bubbleDirection = "bottom";
    var validationAttempt = false;

    /**
     * Création du contrôle.
     */
    function create(){
        var elem = document.querySelector(selector);

        if(elem == undefined){
            console.error("Sélection invalide ou absente.");
            return;
        }

        if(elem.tagName.toLowerCase() != "input"){
            console.error("La sélection doit être un type input texte ou password.");
            return;
        }

        var inputTypes = ['text', 'password'];

        if(inputTypes.indexOf(elem.getAttribute('type').toLowerCase()) == -1){
            console.error("La sélection doit être un type input texte ou password.");
            return;
        }

        var elementConfirm = document.querySelector(elem.getAttribute("pv-confirm-selector"));
        var elementError = document.querySelector(elem.getAttribute("pv-error-selector"));
        required = elem.hasAttribute("pv-required") ? elem.getAttribute("pv-required") != "false" : false;
        bubbleDirection = elem.hasAttribute("pv-direction") ? elem.getAttribute("pv-direction") : "bottom";

        var instance = {
            required: required,
            title: "Doit inclure au minimum:",
            responsiveWidth: 1000,
            responsiveDirection: "top",
            checks: [
                "minCharacters",
                "maxCharacters",
                "minUpper",
                "minLower",
                "minDigits",
                "minSpecial"
            ],
            rules: {
                minCharacters: 8,
                maxCharacters: 0,
                minDigits: 1,
                minLower: 1,
                minUpper: 1,
                minSpecial: 1
            },
            regex: {
                minCharacters: "^.{#,}$",
                maxCharacters: "^.{0,#}$",
                minDigits: "([^0-9]*[0-9]){#,}",
                minLower: "([^a-z]*[a-z]){#,}",
                minUpper: "([^A-Z]*[A-Z]){#,}",
                minSpecial: "([a-zA-Z0-9]*[^a-zA-Z0-9]){#,}",
            },
            elements: {
                main_field: elem,
                confirm_field: elementConfirm,
                error_field: elementError
            },
            i18n: {
                minCharacters: "$0 charactères",
                maxCharacters: "Maximum $0 charactères",
                minDigits: "$0 chiffre",
                minLower: "$0 lettre minuscule",
                minUpper: "$0 lettre majuscule",
                minSpecial: "$0 charactère spécial",
                passwordNoMatch: "Le mot de passe ne correspond pas à la confirmation.",
                passwordInvalid: "Le mot de passe ne répond pas à tous les critères."
            }
        };

        // Définition des règles et langue.
        if(options != undefined){
            if(options.rules != undefined){
                for (var attrname in options.rules) { instance.rules[attrname] = options.rules[attrname]; }
            }
            if(options.regex != undefined){
                for (var attrname in options.regex) { instance.regex[attrname] = options.regex[attrname]; }
            }
            if(options.i18n != undefined){
                for (var attrname in options.i18n) { instance.i18n[attrname] = options.i18n[attrname]; }
            }
            if(options.title != undefined){
                instance.title = options.title;
            }
            if(options.responsiveWidth != undefined){
                instance.responsiveWidth = options.responsiveWidth;
            }
            if(options.responsiveDirection != undefined){
                instance.responsiveDirection = options.responsiveDirection;
            }
        }

        data = instance;

        setTimeout(function(){
            init();
        }, 200);
    }

    /**
     * Initialise le contrôle.
     */
    this.init = function(){
        instanciateBubble("normal");
        instanciateBubble("mobile");

        // Événement click sur le champ mot de passe.
        data.elements.main_field.addEventListener("focus", function(e){
            setTimeout(function(){
                if(document.body.clientWidth < data.responsiveWidth){
                    elBubbleResponsive.style.display = "inline-block";
                }
                else{
                    elBubble.style.display = "inline-block";
                }
                validate();
            },1);
        });
        
        // Événement keydown sur le champ mot de passe.
        data.elements.main_field.addEventListener("keydown", function(e){
            setTimeout(function(){
                validate();
            },1);
        });
        
        // Événement unfocus sur le champ mot de passe.
        data.elements.main_field.addEventListener("blur", function(e){
            setTimeout(function(){
                elBubble.style.display = "none";
                elBubbleResponsive.style.display = "none";
                validate();
            },1);
        });

        if(data.elements.confirm_field != undefined){
            // Événement click sur le champ confirmation de mot de passe.
            data.elements.confirm_field.addEventListener("focus", function(e){
                setTimeout(function(){
                    validate();
                },1);
            });
            
            // Événement keydown sur le champ confirmation de mot de passe.
            data.elements.confirm_field.addEventListener("keydown", function(e){
                setTimeout(function(){
                    validate();
                },1);
            });
            
            // Événement unfocus sur le champ confirmation de mot de passe.
            data.elements.confirm_field.addEventListener("blur", function(e){
                setTimeout(function(){
                    validate();
                },1);
            });
        }

        Element.prototype.validatePasswordInstances.push({
            instance: this,
            data: data
        });

        // Validation initiale.
        setTimeout(function(){
            validate();
        },1);
    }

    /**
     * Création de la bulle.
     */
    function instanciateBubble(type){
        if(type == undefined) type = "normal";
        var el = document.createElement("div");
        var dir = bubbleDirection;

        if(type == "mobile"){
            dir = data.responsiveDirection;
        }

        var html = "<div class='pv-popup-wrapper "+dir+"'>                  \
                        <div class='pv-popup-title'>                        \
                            <span>"+data.title+"</span>                     \
                        </div>                                              \
                        <div class='pv-popup-body'>                         \
                                                                            \
                        </div>                                              \
                        <div class='pv-triangle'></div>                     \
                    </div>                                                  \
                   ";
        el.innerHTML = html;

        var checkDiv = el.querySelector(".pv-popup-body");
        for(var i = 0; i < data.checks.length; i++){
            var name = data.checks[i];
            var display = data.i18n[name];
            var value = data.rules[name];

            if(value == 0){
                continue;
            }

            display = display.replace("$0", value);
            checkDiv.innerHTML += "<div class='pv-popup-check' check-name='"+name+"'><i class='pv-popup-icon'></i><span class='pv-popup-display'> "+display+"</span></div>";
        }

        el.style.position = "absolute";
        data.elements.main_field.parentNode.style.position = "relative";
        
        if(type == "normal"){
            data.elements.main_field.parentNode.appendChild(el);
        }
        else if(type == "mobile"){
            data.elements.main_field.parentNode.appendChild(el);
        }

        var height = el.clientHeight;
        var width = el.offsetWidth;
        
        switch(dir){
            case "top":
                el.style.top = (-height-20)+"px";
                el.style.right = "0";
                break;
            case "bottom":
                el.style.bottom = (-height-20)+"px";
                el.style.right = "0";
                break;
            case "left":
                el.style.left = (-width-30)+"px";
                el.style.top = "0px";
                break;
            case "right":
                el.style.right = (-width-30)+"px";
                el.style.top = "0px";
                break;
        }
        el.style.display = "none";
        el.style.zIndex = "1000";

        if(type == "normal"){
            elBubble = el;
        }
        else if(type == "mobile"){
            elBubbleResponsive = el;
        }
    }

    /**
     * Défini la valeur pour une règle.
     */
    this.setRuleValue = function(name, value){
        data.rules[name] = value;
    }

    /**
     * Défini le texte pour une règle.
     */
    this.setI18N = function(key, value){
        data.i18n[key] = value;
    }

    /**
     * Obtienir les données de l'instance.
     */
    this.getData = function(){
        return data;
    }

    /*
    this.setRule = function(name, regex, value){
        data.regex[name] = regex;
    }
    */

    /**
     * Construit le regex pour une règle.
     */
    function buildRegex(name){
        var regex = data.regex[name];
        var value = data.rules[name];
        var builtRule = regex.replace("#",value);
        var re = new RegExp(builtRule,"g");
        return re;
    }

    /**
     * Vérifie une règle de mot de passe.
     */
    this.validateSingle = function(name){
        var regex = buildRegex(name);
        var elPassword = data.elements.main_field;
        var value = elPassword.value;
        var isMatching = regex.test(value);
        return isMatching;
    }

    /**
     * Vérifie si le mot de passe est valide.
     */
    this.isPasswordValid = function(pass){
        var hasErrors = false;
        for(var i = 0; i < data.checks.length; i++){

            var name = data.checks[i];
            var number = data.rules[name];
            
            var regex = buildRegex(name);
            var value = pass;
            var matching = regex.test(value);

            if(number == 0){
                continue;
            }

            if(!matching){
                hasErrors = true;
            }
            
        }

        return !hasErrors;
    }

    /**
     * Fait la vérification de chaque règles de mot de passe.
     */
    this.validate = function(){
        var checks = data.checks;
        var outData = {};
        var fieldData = [];
        
        var elPassword = data.elements.main_field;
        var elPasswordVerify = data.elements.confirm_field;
        var password = elPassword.value;

        var hasErrors = false;

        for(var i = 0; i < checks.length; i++){

            var name = checks[i];
            var number = data.rules[name];
            var matching = validateSingle(name);
            var display = data.i18n[name];
            display = display.replace("$0",number);

            if(number == 0){
                continue;
            }

            var e = elBubble.querySelector("[check-name='"+name+"']");
            if(matching){
                e.style.color = "#00aa00";
                e.querySelector(".pv-popup-icon").className = "pv-popup-icon fa fa-check";
            }
            else{
                e.style.color = "#ff0000";
                e.querySelector(".pv-popup-icon").className = "pv-popup-icon fa fa-times";
                hasErrors = true;
            }

            e = elBubbleResponsive.querySelector("[check-name='"+name+"']");
            if(matching){
                e.style.color = "#00aa00";
                e.querySelector(".pv-popup-icon").className = "pv-popup-icon fa fa-check";
            }
            else{
                e.style.color = "#ff0000";
                e.querySelector(".pv-popup-icon").className = "pv-popup-icon fa fa-times";
                hasErrors = true;
            }

            var d = {
                display: display,
                valid: matching
            };
            fieldData.push(d);
        }
        outData.fields = fieldData;
        
        if(!required && password.length == 0){
            elPassword.style.border = null;
            outData.error = 0;
            outData.isEmptyAndValid = true;
            return outData;
        }

        outData.error = 0;
        if(elPasswordVerify != undefined){
            var confirmCheck = elPasswordVerify.value == password;
            if(!matching || !confirmCheck){
                if(validationAttempt){
                    elPasswordVerify.style.border = "1px solid red";
                }
                outData.error = 1;
                if(!confirmCheck && validationAttempt){
                    if(data.elements.error_field != undefined)
                        data.elements.error_field.innerHTML = "<span style='color: red;'>"+data.i18n.passwordNoMatch+"</span>";
                }
            }
            else{
                elPasswordVerify.style.border = null;
                outData.error = 0;
                data.elements.error_field.innerHTML = "";
            }
        }

        if(hasErrors){
            if(validationAttempt){
                elPassword.style.border = "1px solid red";
                if(data.elements.error_field != undefined)
                    data.elements.error_field.innerHTML = "<span style='color: red;'>"+data.i18n.passwordInvalid+"</span>";
            }
        }
        else if(outData.error == 0){
            elPassword.style.border = null;
            if(data.elements.error_field != undefined)
                data.elements.error_field.innerHTML = "";
        }

        return outData;
    }

    /**
     * Vérifie si le mot de passe est valide.
     */
    this.isValid = function(){
        validationAttempt = true;
        var result = validate();

        if(result.isEmptyAndValid != undefined && result.isEmptyAndValid){
            validationAttempt = false;
            return true;
        }

        for(i = 0; i < result.fields.length; i++){
            if(!result.fields[i].valid){
                return false;
            }
        }
        if(result.error != 0){
            return false;
        }
        validationAttempt = false;
        return true;
    }

    /**
     * Vérifie si le mot de passe est valide sans afficher les erreurs.
     */
    this.isValidSilent = function(pass){
        var result = validate(pass);
        for(i = 0; i < result.fields.length; i++){
            if(!result.fields[i].valid){
                return false;
            }
        }
        if(result.error != 0){
            return false;
        }
        return true;
    }

    create();
    return this;
});

// Liste d'instances
Element.prototype.validatePasswordInstances = [];

/**
 * Intégration pour sélecteur javascript.
 */
Element.prototype.validatePassword = function(){
    var instance = undefined;
    for(var i = 0; i < Element.prototype.validatePasswordInstances.length; i++){
        var inst = Element.prototype.validatePasswordInstances[i];
        if(inst.data.elements.main_field == this){
            instance = inst;
            break;
        }
    }

    if(instance == undefined){
        return undefined;
    }

    if (instance.instance.isValid()) {
        return true;
    }
    else{
        instance.data.elements.main_field.focus();
        return false;
    }
}

/**
 * Intégration jQuery pour valider.
 */
if(jQuery){
    jQuery.fn.validatePassword = function(){
        var el = this[0];
        return el.validatePassword();
    }
}

function shufferArray(array) {
    var currentIndex = array.length, temporaryValue, randomIndex;
  
    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
  
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
  
      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }
  
    return array;
  }
  

Element.prototype.generatePassword = function(outputSelector, rules){
    
    var len = 8;
    var minUpper = 1;
    var minLower = 1;
    var minNumber = 1;
    var minSpecial = 1;
    var maxUpper = 1;
    var maxLower = 5;
    var maxNumber = 3;
    var maxSpecial = 1;
    var allowedSpecialCharacters = ['~','*','%','@','^','!','?','#','$','_','&'].join("");

    if(rules != undefined){
        if(rules.minUpper != undefined) minUpper = rules.minUpper;
        if(rules.minLower != undefined) minLower = rules.minLower;
        if(rules.minNumber != undefined) minNumber = rules.minNumber;
        if(rules.minSpecial != undefined) minSpecial = rules.minSpecial;
        if(rules.minCharacters != undefined) len = rules.minCharacters;
        if(rules.maxUpper != undefined) maxUpper = rules.maxUpper;
        if(rules.maxLower != undefined) maxLower = rules.maxLower;
        if(rules.maxNumber != undefined) maxNumber = rules.maxNumber;
        if(rules.maxSpecial != undefined) maxSpecial = maxSpecial.maxSpecial;
        if(rules.allowedSpecialCharacters != undefined) allowedSpecialCharacters = rules.allowedSpecialCharacters;
    }
    
    var element = outputSelector != "" ? document.querySelector(outputSelector) : undefined;

    var chars = "abcdefghijklmnopqrstuvwxyz0123456789", //chars
    A2Z = "ABCDEFGHIJKLMNOPQRSTUVWXYZ", //A-Z
    a2z = "abcdefghijklmnopqrstuvwxyz", //a-z
    zero2nine = "0123456789", //0-9
    specials = allowedSpecialCharacters;

    chars = a2z;

    if (minNumber < 0) chars = chars.replace(zero2nine, '')

    chars = chars.replace('l', ''); // Exclure l minuscule
    chars = chars.replace('I', ''); // Exclure I majuscule
    A2Z = A2Z.replace('I',''); // Exclure I majuscule
    a2z = a2z.replace('l',''); // Exclure l minuscule

    var rs = [];
    var leftOver = len;

    var specialLen = Math.floor(Math.random() * (maxSpecial - minSpecial + 1)) + minSpecial;
    for(i = 0; i < specialLen && leftOver > 0; i++){
        rs.push(specials[Math.floor(Math.random() * specials.length)]);
        leftOver--;
    }

    var upperLen = Math.floor(Math.random() * (maxUpper - minUpper + 1)) + minUpper;
    for(i = 0; i < upperLen && leftOver > 0; i++){
        rs.push(A2Z[Math.floor(Math.random() * A2Z.length)]);
        leftOver--;
    }

    var lowerLen = Math.floor(Math.random() * (maxLower - minLower + 1)) + minLower;
    for(i = 0; i < lowerLen && leftOver > 0; i++){
        rs.push(a2z[Math.floor(Math.random() * a2z.length)]);
        leftOver--;
    }

    var numberLen = Math.floor(Math.random() * (maxNumber - minNumber + 1)) + minNumber;
    for(i = 0; i < numberLen && leftOver > 0; i++){
        rs.push(zero2nine[Math.floor(Math.random() * zero2nine.length)]);
        leftOver--;
    }

    for(i = 0; i < leftOver; i++){
        rs.push(chars[Math.floor(Math.random() * chars.length)]);
    }

    var shuffeled = shufferArray(rs);

    var newpass = shuffeled.join('');

    if(element != undefined){
        element.value = newpass;
    }

    return newpass;
}

if(jQuery){
    $.fn.generatePassword = function(outputSelector, rules){
        return $(this)[0].generatePassword(outputSelector, rules);
    }
}

module.exports = PasswordValidation;